import { type BrandTheme } from '@owner/theme'
import Vue from 'vue'

import type { CoreState } from '../../types'

export const SET_THEME = (state: CoreState, theme: BrandTheme): void => {
  Vue.set(state, 'theme', theme)
}
